import React from 'react';
import { Grid, Box, TextField, Button, Typography, Divider } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import { sendContactUsMessage } from 'services/contactUs';
import HomeIcon from '@mui/icons-material/Home';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const defaultFormValues = {
  name:'',
  email: '',
  subject: '',
  message: ''
}

const ContactUs = () => {

  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormValues}
  });

  const onSubmit = (data) => {
    const postData = { ...data };
    console.log('postData', postData);

    sendContactUsMessage({...postData }).then(({response, error}) => {
      if(response){
        enqueueSnackbar(('Your query has been submitted successfully. We\'ll get back to you shortly.'), {variant: 'success'});
        reset({...defaultFormValues})
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
      {/* <Typography variant="subtitle2"  sx={{mt: 1, mb: 3}}>
        Update account details
      </Typography> */}
      <Grid container columnSpacing={2} rowSpacing={0}>
        <Grid container item xs={12} sm={12} md={12} lg={12}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Controller
              control={control}
              name="name"
              id="name"
              rules={{
                required: "Enter your name",
              }}
              render={({field }) => (
                <TextField
                  type="text"
                  {...field}
                  margin="normal"
                  fullWidth
                  size="small"
                  autoFocus
                  label="Name"
                  required
                  error={errors.name?.type === 'required'}
                  helperText={errors.name?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="email"
              id="email"
              rules={{
                required: "Enter your email address", 
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Enter a valid email address",
                }, 
              }}
              render={({field}) => (
                <TextField
                  {...field}
                  type="email"
                  margin="normal"
                  label="Email"
                  required
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="subject"
              id="subject"
              rules={{
                required: "Enter subject",
                // minLength: { value: 6, message: 'Password must be atlease 6 characters' },
                // validate: (value) => value === watch('newPassword') || "Password fields don't match"
              }}
              render={({field}) => (
                <TextField
                  {...field}
                  type="text"
                  margin="normal"
                  label="Subject"
                  required
                  error={!!errors.subject}
                  helperText={errors.subject?.message}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="message"
              id="message"
              rules={{
                required: "Enter message",
                // minLength: { value: 6, message: 'Password must be atlease 6 characters' },
                // validate: (value) => value === watch('newPassword') || "Password fields don't match"
              }}
              render={({field}) => (
                <TextField
                  {...field}
                  type="text"
                  margin="normal"
                  label="Message"
                  multiline
                  rows={4}
                  required
                  error={!!errors.message}
                  helperText={errors.message?.message}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              color="success"
            >
              Send Message
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 1, px: 2}}>
          <Typography variant='h6'>
            Contact Info
          </Typography>
          <Divider />

          <Typography variant='body1' sx={{my: 1}} component="div">
            <HomeIcon sx={{p: .5, verticalAlign: 'bottom', mr: 1}} />
            VINZERO (OPC) PRIVATE LIMITED<br />
            <address style={{marginLeft: '2rem'}}>
              #30, 1st Floor, Gantiganahalli,<br />
              Yelahanka, Bangalore-560064<br />
            </address>
          </Typography>

          <Typography variant='body1' sx={{my: 1}}>
            <a href="mailto:info@webook.org" style={{color: "#000"}}> <EmailIcon sx={{p: .5, verticalAlign: 'bottom', mr: 1}} />info@webook.org</a>
          </Typography>

          <Typography variant='body1' sx={{my: 1}}>
            <a href="tel:+919900307928" style={{color: "#000"}}> <LocalPhoneIcon sx={{p: .5, verticalAlign: 'bottom',mr: 1}} />+919900307928</a>
          </Typography>

        </Grid>
      </Grid>
    </Box>
  );
}
 
export default ContactUs;
